var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-list"},[_c('li',{staticClass:"new-list__content"},[_vm._v(" 👉 "+_vm._s(_vm.todo)+" "),_c('button',{staticClass:"button-remove",on:{"click":function($event){return _vm.removeTodo(_vm.index)}}},[_vm._v("✖")])])])}
var staticRenderFns = []

export { render, staticRenderFns }